import { doIntegrationsWriteRequest } from 'ducks/requests'
import doCreateShopifyEvent from './doCreateShopifyEvent'
import { ORDER_CANCEL_REQUEST } from '../types'

const doCancelOrder = (
  integrationId,
  orderId,
  conversationId,
  data
) => async dispatch => {
  const url = `proxy/shopify/admin/api/2021-10/orders/${orderId}/cancel.json?gid=${integrationId}`

  if (orderId && conversationId) {
    dispatch(doCreateShopifyEvent(orderId, conversationId, 'ORDER_CANCELED'))
  }

  const result = await dispatch(
    doIntegrationsWriteRequest(ORDER_CANCEL_REQUEST, url, data, {
      moduleOptions: {
        toasts: {
          enabled: true,
          started: {
            enabled: false,
          },
          success: {
            enabled: true,
            content: 'Order cancelled',
          },
          failed: {
            enabled: true,
            content: 'Order cancellation failed',
          },
        },
      },
    })
  )

  if (orderId && conversationId) {
    dispatch(
      doCreateShopifyEvent(
        integrationId,
        orderId,
        conversationId,
        'ORDER_CANCELED'
      )
    )
  }

  return result
}

export default doCancelOrder
